<template>
  <el-tabs v-model="card_index" @tab-click="handleClick">
    <el-tab-pane label="异动总览" name="MeterOrderUnusualChangeAll">
      <MeterOrderUnusualChangeAll v-if="card_index === 'MeterOrderUnusualChangeAll'" />
    </el-tab-pane>
    <el-tab-pane label="用量-分摊" name="MeterOrderUnusualChange1">
      <MeterOrderUnusualChange1 v-if="card_index === 'MeterOrderUnusualChange1'" />
    </el-tab-pane>
    <el-tab-pane label="用户-账单" name="MeterOrderUnusualChange2">
      <MeterOrderUnusualChange2 v-if="card_index === 'MeterOrderUnusualChange2'" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import MeterOrderUnusualChangeAll from "./components/MeterOrderUnusualChangeAll";
import MeterOrderUnusualChange1 from "./components/MeterOrderUnusualChange1";
import MeterOrderUnusualChange2 from "./components/MeterOrderUnusualChange2";
export default {
  name: "MeterOrderUnusualChange",
  components: {MeterOrderUnusualChangeAll,MeterOrderUnusualChange1,MeterOrderUnusualChange2},
  data() {
    return {
      card_index: "MeterOrderUnusualChangeAll"
    };
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/MeterOrderUnusualChange.vue